// components/Navigation.tsx - Navigation Component
import React from 'react';
import { MapPin, CreditCard, Users, Package, BarChart3 } from 'lucide-react';
import { TabType, UserRole } from '../types';

interface NavigationProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  userRole: UserRole;
}

const Navigation: React.FC<NavigationProps> = ({ activeTab, setActiveTab, userRole }) => {
  const iconMap = {
    MapPin,
    CreditCard,
    Users,
    Package,
    BarChart3
  };

  const navigationTabs = [
    { id: 'properties' as TabType, name: 'Properties', icon: 'MapPin', role: 'all' },
    { id: 'payments' as TabType, name: 'Payments', icon: 'CreditCard', role: 'all' },
    { id: 'users' as TabType, name: 'Users', icon: 'Users', role: 'admin' },
    { id: 'assets' as TabType, name: 'Assets', icon: 'Package', role: 'admin' },
    { id: 'reports' as TabType, name: 'Reports', icon: 'BarChart3', role: 'all' }
  ].filter(tab => tab.role === 'all' || (tab.role === 'admin' && userRole === 'admin'));

  return (
    <div className="flex bg-gray-50 border-t border-gray-200">
      {navigationTabs.map(tab => {
        const IconComponent = iconMap[tab.icon as keyof typeof iconMap];
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 flex flex-col items-center py-4 px-3 text-sm transition-all duration-200 ${
              activeTab === tab.id 
                ? 'bg-white text-green-600 border-t-2 border-green-600 shadow-sm' 
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
            }`}
          >
            <IconComponent className="w-5 h-5 mb-1" />
            <span className="font-medium">{tab.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default Navigation;